import {
    AlertTypes,
    GenericFormContainer,
    IAlertData,
    Leap4Breadcrumbs, Mode,
    Spinner,
    apiClient,
    MuiIcons
} from "@leap4/frontend";
import {EditOrganizationStore} from "./EditOrganizationStore";
import {useParams} from "react-router-dom";
import {useEffect, useMemo, useState} from "react";
import {OrganizationsBaseUrl} from "../../../../config/generals";
import {RootState} from "../../../../store/store";
import {connect, ConnectedProps, useDispatch} from "react-redux";
import {urlService} from "../../../routing/urlsService";
import {IOrganization} from "../../interfaces/IOrganization";
import { OrganizationContext, IClientCredentials, ISavedPartnersByOrg } from "../OrganizationContex";
import {DetailsForm} from "../DetailsForm";
import {initialOrganizationObj} from "../Organization"
import {submitAndDeleteOrganization} from "../../../../actions/users";
import {setAlert} from "../../../../actions/alert";

const {Toc: TocIcon} = MuiIcons;

const mapStateToProps = (state: RootState) => ({});

const mapActions = {
    setAlert
}

export interface IEditGroupProps extends PropsFromRedux {
    setGroup: (data: IAlertData) => void;
    setAlert: any;
}

const connector = connect(mapStateToProps, mapActions);
type PropsFromRedux = ConnectedProps<typeof connector>;

let editOrganizationStore: EditOrganizationStore

const extractSavedPartners = (org: IOrganization): ISavedPartnersByOrg => {
    const login = org?.publisherLogin ?? {};
    return Object.keys(login).reduce((acc, orgId) => {
        acc[orgId] = login[orgId]?.partners ?? [];
        return acc;
    }, {} as ISavedPartnersByOrg);
};

const _editOrganization = (props: IEditGroupProps) => {
    const {setGroup, setAlert} = props
    const params = useParams<{ id?: string }>();
    const dispatch = useDispatch();
    const [organization, setOrganization] = useState<IOrganization>(initialOrganizationObj);
    const [clientCredentials, setClientCredentials] = useState<IClientCredentials | null>(null);
    const [savedPartnersByOrg, setSavedPartnersByOrg] = useState<ISavedPartnersByOrg>({});
    const organizationsContextValue = useMemo(
        () => ({organization, setOrganization, clientCredentials, setClientCredentials, savedPartnersByOrg}),
        [organization, clientCredentials, savedPartnersByOrg]
    );
    const [isLoading, setIsLoading] = useState(false)
    const [isLoadError, setIsLoadError] = useState(false)

    const onSubmit = async () => {
        try {
            setIsLoading(true)
            const res = await submitAndDeleteOrganization(dispatch, organization );
            if (res !== undefined) {
                setSavedPartnersByOrg(extractSavedPartners(organization));
                setAlert("Organization saved", AlertTypes.SUCCESS)
            }
        } catch(err) {
            setAlert({msg: err.toString(), type: AlertTypes.FAILURE})
        } finally {
            setIsLoading(false)
        }
    };


    useEffect(() => {
        if (!params.id) {
            return;
        }
        editOrganizationStore = new EditOrganizationStore({
                setIsLoading,
                setIsLoadError,
                setItem: (x) => {setOrganization(x); setSavedPartnersByOrg(extractSavedPartners(x))},
                axiosClient: apiClient,
                alertFunc: setGroup,
                baseUrl: `${OrganizationsBaseUrl}`
            }
        )
        editOrganizationStore.refreshItem(params.id)
    }, [params.id])

    if (isLoadError) {
        return (<>Error Loading the page</>);
    }
    if (isLoading) {
        return (<Spinner/>);
    }

    return (
        <>
            <Leap4Breadcrumbs breadcrumbs={[{
                text: organization?.name,
                link: urlService.organizations(),
                icon: <TocIcon/>
            },
                ]}
            />
            <GenericFormContainer mode={Mode.Edit} onCreateOrEditFunc={onSubmit} buttonsProps={{delete: {"disabled":true}}}>
                <OrganizationContext.Provider value={organizationsContextValue}>
                    <DetailsForm />
                </OrganizationContext.Provider>
            </GenericFormContainer>
        </>
    )
}

export const editOrganization = connect(mapStateToProps, {
    setAlert
})(_editOrganization);
